import { Button, styled } from "@mui/material";

export const HeaderToolButton = styled(Button)({
  color: "white",
  borderColor: "#9c9c9c",
  display: "flex",
  padding: "4px",
  textTransform: "none",
});
